import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Check if user is admin (logged in)
const isAdminUser = () => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  return !!(token && user);
};

// Generate or get visitor ID
const getVisitorId = () => {
  let visitorId = localStorage.getItem('visitor_id');
  if (!visitorId) {
    visitorId = 'v_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
    localStorage.setItem('visitor_id', visitorId);
  }
  return visitorId;
};

// Track page view
const trackPageView = async (page) => {
  // Don't track if admin is logged in
  if (isAdminUser()) {
    console.debug('Analytics: Skipping tracking (admin user)');
    return;
  }
  
  try {
    await fetch(`${BACKEND_URL}/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        visitor_id: getVisitorId(),
        page: page,
        referrer: document.referrer || ''
      })
    });
  } catch (error) {
    // Silently fail - don't break the app for analytics
    console.debug('Analytics tracking failed:', error);
  }
};

// Track specific events
export const trackEvent = async (eventType, eventData = {}) => {
  // Don't track if admin is logged in
  if (isAdminUser()) {
    console.debug('Analytics: Skipping event tracking (admin user)');
    return;
  }
  
  try {
    await fetch(`${BACKEND_URL}/api/analytics/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        visitor_id: getVisitorId(),
        event_type: eventType,
        event_data: eventData,
        page: window.location.pathname
      })
    });
  } catch (error) {
    console.debug('Event tracking failed:', error);
  }
};

// Hook to automatically track page views
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Don't track admin pages
    if (location.pathname.startsWith('/admin')) {
      return;
    }
    
    trackPageView(location.pathname);
  }, [location.pathname]);
};

// Convenience functions for common events
export const trackPhoneClick = () => trackEvent('phone_click');
export const trackWhatsAppClick = () => trackEvent('whatsapp_click');
export const trackContactFormView = () => trackEvent('contact_form_view');
export const trackContactFormSubmit = () => trackEvent('contact_form_submit');
export const trackCTAClick = (buttonName) => trackEvent('cta_click', { button: buttonName });
export const trackProjectView = (projectId) => trackEvent('project_view', { project_id: projectId });

export default usePageTracking;
